<template>
  <div class="animated fadeIn">
    <!-- <img src="img/ccpl_logo.png" width="250px" class="d-block my-3" style="margin: auto"> -->
    <h3 v-if="$mq !== 'sm'" class="text-center mb-5">
      Welcome Home,
      {{ `${user.USER_PROFILE_FIRST_NAME} ${user.USER_PROFILE_LAST_NAME}` }}
    </h3>
    <h6 v-if="$mq === 'sm'" class="text-center mb-5">
      Welcome Home,
      {{ `${user.USER_PROFILE_FIRST_NAME} ${user.USER_PROFILE_LAST_NAME}` }}
    </h6>
    <b-row class="mb-3">
      <b-col md="6">
        <h4>Dashboard</h4>
      </b-col>
      <b-col md="6">
        <div class="d-flex justify-content-end" :class="{'mt-3': $mq === 'sm'}">
          <span class="mr-3">Sort by</span>
          <b-select v-model="sortBy" size="sm" style="max-width: 125px">
            <option value="timeDue">Date Due</option>
            <option value="daysDifference">Days Left</option>
          </b-select>
          <b-btn
            variant="primary"
            size="sm"
            class="ml-3"
            title="Sort order"
            :disabled="!sortBy"
            @click="sort">
            <i class="fa" :class="sortIcon" />
          </b-btn>
        </div>
      </b-col>
    </b-row>
    <b-alert :show="!dashboardItems.length && !isFetching" variant="info">
      <span>No Vehicles Found</span>
    </b-alert>
    <div v-for="item in dashboardItems" :key="`${item.vehicleId}${item.vehicleNumber}`" class="mb-3">
      <b-row class="item-list py-2">
        <b-col md="6">
          <i class="fa fa-bell text-danger m3-3" />
          {{ `${item.vehicleNumber} ${item.make} ${item.model} - ${item.isDanger ? 'Time Service Due' : 'Mileage Service Due'}` }}
        </b-col>
        <b-col v-if="item.isDanger" md="2">
          <span>Date Due: <b>{{ item.timeDue | date('DD/MM/YYYY') }}</b></span>
        </b-col>
        <b-col v-if="item.isDanger" md="2">
          <span>Days Left: <b>{{ item.daysDifference }}</b></span>
        </b-col>
        <b-col v-if="!item.isDanger" md="2">
          <span>ODO: <b>{{ item.OdometerReading }}</b></span>
        </b-col>
        <b-col v-if="!item.isDanger" md="2">
          <span>Mileage Due: <b>{{ item.mileageServiceDue }}</b></span>
        </b-col>
        <b-col v-if="!item.isDanger" md="2">
          <span>Diff: <b>{{ item.mileageServiceDifference }}</b></span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { auth } from '@/services'
import moment from 'moment'

export default {
  name: 'Dashboard',
  data () {
    return {
      vehicles: [],
      isFetching: false,
      sortBy: '',
      sortOrder: '',
      sortOptions: [
        { text: 'Date Due', value: 'timeDue' },
        { text: 'Days Left', value: 'daysDifference' }
      ]
    }
  },
  computed: {
    ...mapState('vmts', ['dashboardItems']),
    user () {
      return auth.getUser()
    },
    sortIcon() {
      if (this.sortOrder === '') return 'fa-sort'
      return this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc'
    }
  },
  watch: {
    sortBy(nV, oV) {
      if (nV !== oV) {
        this.sortOrder = ''
      }
    }
  },
  created () {
    this.getVehicleList()
  },
  methods: {
    async getVehicleList() {
      try {
        this.isFetching = true
        await this.$store.dispatch('vmts/getVehicleList')
        this.isFetching = false
      } catch (err) {
        console.log(err)
      }
    },
    getDaysLeft(timeDue) {
      return moment(timeDue).diff(moment(new Date()), 'd')
    },
    sort() {
      if (!this.sortBy) return
      if (this.sortOrder === '') {
        this.sortOrder = 'desc'
      } else {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      }
      this.$store.dispatch('vmts/sortDashboardItems', { sortBy: this.sortBy, sortOrder: this.sortOrder })
    }
  }
}
</script>
<style lang="scss" scoped>
.item-list {
  border: 1px solid black;
}
</style>